export const filterData = (data) => Object.fromEntries(Object.entries(data).filter(([_, value]) => {
  return value !== '';
}));

export const createActionId = (sessionId, fallbackSessionId) => {
  if (!sessionId || sessionId === fallbackSessionId) {
    return `${crypto.randomUUID()}_${Date.now().toString()}`;
  }
  return `${sessionId}_${Date.now().toString()}`;
};